import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {getAmplitudeOfferListItem} from "./get_amplitude_offer_list_item";
import {AmplitudeItemListName} from "./get_amplitude_view_item_event_properties";

export interface ITrackAmplitudeOfferViewItemListParams {
    offers: IOfferListOffer[];
    itemListId?: string;
    itemListName: AmplitudeItemListName;
}

export const trackAmplitudeOfferViewItemList = (params: ITrackAmplitudeOfferViewItemListParams) => {
    const {offers, itemListId, itemListName} = params;

    trackAmplitudeEvent("view_item_list", {
        ...(itemListId ? {item_list_id: itemListId} : {}),
        item_list_name: itemListName,
        PRODUCTS: offers.map((offer, index) => getAmplitudeOfferListItem({offer, index: index + 1}))
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {getAmplitudeOfferListItem} from "./get_amplitude_offer_list_item";
import {AmplitudeItemListName} from "./get_amplitude_view_item_event_properties";

export interface ITrackAmplitudeOfferViewItemListParams {
    offers: IOfferListOffer[];
    itemListId?: string;
    itemListName: AmplitudeItemListName;
}

export const trackAmplitudeOfferViewItemList = (params: ITrackAmplitudeOfferViewItemListParams) => {
    const {offers, itemListId, itemListName} = params;

    trackAmplitudeEvent("view_item_list", {
        ...(itemListId ? {item_list_id: itemListId} : {}),
        item_list_name: itemListName,
        PRODUCTS: offers.map((offer, index) => getAmplitudeOfferListItem({offer, index: index + 1}))
    });
};
